import { ThemeConfig } from "react-select";

export const brandSelectTheme: ThemeConfig = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: "#1F65B1",
    primary25: "rgba(31, 101, 177, 0.15)",
    primary50: "rgba(31, 101, 177, 0.4)",
    primary75: "#0B4F8D",
  },
});
